// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ConnectWallet_text-gradient__3FDyL","container":"ConnectWallet_container__3eC_-"};